import { render } from "./WordListItem.vue?vue&type=template&id=40ff2120&scoped=true&ts=true"
import script from "./WordListItem.vue?vue&type=script&lang=ts"
export * from "./WordListItem.vue?vue&type=script&lang=ts"

import "./WordListItem.vue?vue&type=style&index=0&id=40ff2120&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ff2120"]])

export default __exports__